import React from 'react'
import style from './style.module.css'
import LetterSvg from '../../../../assets/Letter.svg'
import { APP_NAME } from '../../../../constants/app'

export const EmailVerified = () => {
  return (
    <>
      <img
        style={{ width: '156px', height: '156px' }}
        src={LetterSvg}
        alt="Letter"
      />
      <h2 className={style.contentTitle}>Email successfully verified</h2>
      <p className={style.contentDescription}>
        Get started by downloading our {APP_NAME} to your mobile device.
      </p>
    </>
  )
}

export default EmailVerified
